import { render, staticRenderFns } from "./tr.vue?vue&type=template&id=9478b44c&"
import script from "./tr.vue?vue&type=script&lang=js&"
export * from "./tr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports